var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.647,15.971c1.113-0.489,1.727-1.006,1.727-1.543c0-2.958-18.073-5.356-40.374-5.356  c-22.293,0-40.374,2.397-40.374,5.356c0,0.537,0.613,1.054,1.728,1.543c-1.114,0.489-1.728,1.007-1.728,1.544  c0,1.708,6.07,3.227,15.483,4.208c0.026,0.201,0.086,0.398,0.207,0.574l22.948,33.217L25.316,88.73  c-0.427,0.615-0.247,1.485,0.402,1.925c0.652,0.46,1.523,0.321,1.946-0.298l22.338-32.328l22.334,32.328  c0.427,0.619,1.301,0.758,1.95,0.298c0.652-0.441,0.832-1.31,0.405-1.925L51.74,55.514l22.951-33.217  c0.122-0.176,0.182-0.373,0.208-0.574c9.41-0.981,15.475-2.5,15.475-4.208C90.374,16.978,89.76,16.46,88.647,15.971z M50.002,52.999  L28.617,22.049c6.206,0.516,13.52,0.82,21.383,0.82c7.864,0,15.178-0.303,21.383-0.82L50.002,52.999z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.23bc0fda74a3aca818732d72dc00197a.svg";
export { ForwardRef as ReactComponent };